export const edgemailClerkTheme = {
  variables: {
    colorPrimary: '#ff5600',
    colorBackground: '#faf9f6',
    colorText: '#111111',
    colorTextSecondary: '#7b7b78',
    colorInputBackground: '#ffffff',
    colorInputText: '#111111',
    colorDanger: '#c41c1c',
    borderRadius: '4px',
    fontFamily: '"Saans", "Inter var", system-ui, -apple-system, sans-serif',
  },
  elements: {
    cardBox: {
      boxShadow: 'none',
      border: 'none',
      backgroundColor: 'transparent',
    },
    card: {
      boxShadow: 'none',
      border: 'none',
      backgroundColor: 'transparent',
    },
    headerTitle: {
      color: '#111111',
      fontSize: '28px',
      letterSpacing: '-0.03em', // tighter tracking for premium feel
      lineHeight: '1.05',
      fontFamily: '"Saans", "Inter var", sans-serif',
      fontWeight: '600',
    },
    headerSubtitle: {
      color: '#7b7b78',
      fontSize: '14px',
    },
    formButtonPrimary: {
      boxShadow: 'none',
      transition: 'transform 150ms ease-in-out',
      borderRadius: '4px',
      border: '1px solid #ff5600',
      minHeight: '44px',
      fontSize: '15px',
      textTransform: 'none', // Ensure normal button casing
      '&:hover': {
        transform: 'scale(1.08)',
        backgroundColor: '#ffffff',
        color: '#ff5600',
        borderColor: '#ff5600'
      },
      '&:active': {
        transform: 'scale(0.96)'
      }
    },
    socialButtonsBlockButton: {
      boxShadow: 'none',
      borderRadius: '4px',
      border: '1px solid #111111',
      backgroundColor: '#ffffff',
      color: '#111111',
      minHeight: '44px',
      transition: 'transform 150ms ease-in-out',
      '&:hover': {
        transform: 'scale(1.04)', // Slight scale for social buttons
        backgroundColor: '#111111',
        color: '#ffffff'
      }
    },
    socialButtonsBlockButtonText: {
      fontWeight: '500',
    },
    dividerLine: {
      backgroundColor: '#dedbd6',
    },
    dividerText: {
      color: '#7b7b78',
    },
    formFieldInput: {
      boxShadow: '0 1px 2px rgba(0,0,0,0.02)',
      borderRadius: '6px',
      border: '1px solid #d1d5db',
      backgroundColor: '#ffffff',
      minHeight: '44px',
      padding: '0 12px',
      fontSize: '15px',
      '&:focus': {
        borderColor: '#ff5600',
        boxShadow: '0 0 0 2px #ff5600',
      }
    },
    formFieldLabel: {
      color: '#111111',
      fontWeight: '500',
      marginBottom: '6px',
    },
    footerActionLink: {
      color: '#ff5600',
      fontWeight: '600',
      '&:hover': {
        color: '#111111',
      }
    },
    footer: {
      background: 'transparent',
      border: 'none',
      '& + div': {
        display: 'none !important',
      }
    },
    loaderIcon: {
      color: '#ff5600'
    }
  }
};
